module.exports = __webpack_public_path__ + "static/media/in.20177402.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/in.svg
// module id = 112
// module chunks = 0